<template>
  <tr class="screener-detailed-row" :class="user.status=='COMPLETED'?'active':''" @click="$emit('to-screener', user.id)">
    <td class="screener-detailed-col">
      <h4 @click="$emit('to-screener', user.id)" class="screener__name">
        {{ user.title }}
      </h4>
    </td>
    <td class="screener-detailed-col">
      <v-chip
        x-small
        color="accent"
      >{{user.status.toLowerCase()}}</v-chip>
    </td>
    <td class="screener-detailed-col">
      <span class="bhGray2--text text-nowrap">
        {{ user.creationDate | moment('MMMM Do, YYYY') }}
      </span>
    </td>
    <td class="screener-detailed-col">
      <span class="bhGray2--text text-nowrap">
        {{ user.startDate | moment('MMMM Do, YYYY') }}
      </span>
    </td>
    <td class="screener-detailed-col score">
      <span class="text-nowrap" v-if="user.score">
        {{ user.score }}
      </span>
    </td>
    <td class="screener-detailed-col">
      <v-btn
        v-if="user.status=='COMPLETED'"
        icon
        color="accent"
        elevation="0"
        @click="$emit('to-screener', user.id)"
      >
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'ScreenersDetailedTableRow',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
  },
}
</script>

<style lang="scss">
.screener-detailed {
  &__name {
    // what about wrapping names?
    min-width: 150px;
    max-width: 200px;
    margin-bottom: 4px;
    cursor: pointer;

    // do we hant hover style?
    // &:hover {
    //   text-decoration: underline;
    // }
  }
  &-row {
    border-radius: $border-radius-root;
    background: transparent !important;
    overflow: hidden;

    &.active {
      cursor: pointer;
      .screener-detailed-col {
        background: $bh-white;
      }
    }
    .screener-detailed-col {
      background: $bh-gray--6;
    }
  }

  &-col {
    padding: 8px !important;
    border-bottom: 0 !important;

    strong {
      display: inline-block;
      margin-bottom: 4px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p {
      font-size: 0.857rem;
      line-height: 1rem;
    }

    p:last-child {
      margin-bottom: 0;
    }

    &:first-of-type {
      min-width: 0;
      border-top-left-radius: $border-radius-root;
      border-bottom-left-radius: $border-radius-root;
    }

    &:last-of-type {
      min-width: 0;
      border-top-right-radius: $border-radius-root;
      border-bottom-right-radius: $border-radius-root;
      text-align: right;
    }
    .v-chip {
      text-transform: capitalize;
      font-weight: 500;
    }
    .text-number {
      font-size: 1.125rem;
    }
    &.score {
      font-weight: 600;
      font-size: 1rem !important;
    }
  }
}
</style>
